import moment from 'moment';

export default (dateString: string) =>
  moment(dateString)
    .add('3', 'months')
    .format('x');
